import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { BackendResponse, Task, TaskPayload } from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { HttpEntityManager } from '../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class TasksService extends HttpEntityManager<Task, Task> {
  entityName: WebsocketEntTypes = 'task';
  wsManager = new WSEntityManager(this.webSocketService, this.entityName);
  tableTasksManager = new WSEntityManager(
    this.webSocketService,
    this.entityName
  );
  smaManager = new WSEntityManager(this.webSocketService, 'sma');

  constructor(
    protected http: HttpClient,
    private webSocketService: WebSocketService
  ) {
    super();
  }

  readonly webSocketIsAlive$ = this.webSocketService.getWebSocketIsAlive$();

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>,
    mysid: string
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({ ...payload, mysid });
  }

  subscribeSingleTask(taskId: string): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({
      id: taskId,
      cmd: 'get',
      view: 'dtl',
      s: 'model',
    });
  }

  createTask(payload: TaskPayload, mysid: string): void {
    this.wsManager.create({ res: payload, mysid });
  }

  updateTask(payload: TaskPayload, mysid: string, id: string): void {
    this.wsManager.update({ res: payload, mysid, id });
  }

  deleteTasks(taskIds: string[], mysid: string): void {
    const deletePayload = taskIds.map(id => ({ _id: id }));
    this.wsManager.bulkDelete({
      mysid: mysid,
      res: deletePayload,
    });
  }

  getDealsForTask(): Observable<BackendResponse<any[]>> {
    return this.http.get<BackendResponse<any[]>>(
      '/api/v1/service/deals/summary',
      {
        withCredentials: true,
      }
    );
  }
}
